const getCookie = ( name ) => {
	const cookie = document.cookie
		.split( '; ' )
		.find( ( item ) => item.startsWith( `${ name }=` ) );

	return cookie ? decodeURIComponent( cookie.split( '=' ).slice( 1 ).join( '=' ) ) : '';
};

export default function initAjaxPagination() {
	const link = document.querySelector( '#ajax-load-more' );
	if ( ! link ) return;

	link.addEventListener( 'click', async ( event ) => {
		event.preventDefault();

		const postsHolder = document.querySelector( link.dataset.postsHolder );
		if ( ! postsHolder ) return;

		postsHolder.classList.add( 'is-loading' );

		const body = new URLSearchParams( {
			action: 'ajax_load_posts',
			query: link.dataset.currentQuery || '',
			post_type: link.dataset.postType || '',
			offset: postsHolder.querySelectorAll( 'article' ).length,
			nonce: getCookie( 'wordpress_sig_ajax_nonce' ),
		} );

		try {
			const response = await fetch( themeVars.ajaxurl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body,
			} );
			const answer = await response.json();

			if ( ! response.ok || ! answer.html ) {
				throw new Error( 'Unable to load more posts.' );
			}

			postsHolder.insertAdjacentHTML( 'beforeend', answer.html );
			link.dataset.currentQuery = JSON.stringify( answer.query );
			link.hidden = Boolean( answer.hide_link );
		} catch ( error ) {
			console.error( error );
		} finally {
			postsHolder.classList.remove( 'is-loading' );
		}
	} );
}
